<div class="cd-textarea">
  <div class="l-d-f l-jc-sb cds-body2 l-mb-0">
    <span>{{ label }}</span>
    @if (maxlength) {
    <span>{{ currentLength }}/{{ maxlength }}</span>
    }
  </div>
  <div class="l-mt-2" [style.height]="height">
    <textarea
      [value]="internalValue"
      (input)="onInput($event)"
      class="the-textarea cds-body1 l-mb-0 l-pa-4"
      [style.fontSize]="fontSize"
      [placeholder]="placeholder"
      [attr.maxlength]="maxlength ?? null"
      maxrow></textarea>
  </div>
</div>
